import { Button, Input } from '@scuf/common';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSetRecoilState } from 'recoil';
import { notificationAtom } from 'resources';
import { downloadFileExcel } from 'resources/api/MaintenancesReport_api/fileMaintenance';

function MaintenanceReportExport() {
    const [dateStart, setDateStart] = useState<string>('');
    const [dateEnd, setDateEnd] = useState<string>('');
    const { t } = useTranslation(['spareparts', 'common']);
    const [loading, setLoading] = useState<boolean>(false);
    const setNotification = useSetRecoilState(notificationAtom);

    const handleSuccess = () => setNotification({ type: "success", message: "Report" });
    const handleError = () => setNotification({ type: 'information', message: "NoData" });

    useEffect(() => {
        setEmptyValue();
    }, []);

    useEffect(() => {
        enableButton();
    }, [dateStart, dateEnd]);

    const handleReport = async () => {
        setLoading(true);

        await downloadFileExcel(
            { DateEnd: dateEnd, DateStart: dateStart },
            `report_${dateStart}-${dateEnd}.xlsx`,
            handleSuccess,
            handleError
        );

        setLoading(false);
    };

    function setEmptyValue() {
        setDateStart('');
        setDateEnd('');
    }

    const enableButton = () => {
        return dateStart !== '' && dateEnd !== '';
    };

    return (
        <div className="form3Columns">
            <div>
                <Input
                    label={t('maintenancereport:translation.StartDate')}
                    type="date"
                    value={dateStart}
                    required
                    onChange={setDateStart}
                />
                <Input
                    label={t('maintenancereport:translation.EndDate')}
                    type="date"
                    value={dateEnd}
                    required
                    onChange={setDateEnd}
                />
            </div>

            <div className="buttonsSearch">
                <Button
                    type="secondary"
                    icon="badge-delete"
                    content={t('common:actions.ResetFilters')}
                    onClick={setEmptyValue}
                    iconPosition="right"
                />
                <Button
                    type="primary"
                    icon="report"
                    content={t('common:actions.Generate')}
                    loading={loading}
                    iconPosition="right"
                    disabled={!enableButton()}
                    onClick={handleReport}
                />
            </div>
        </div>
    );
}

export default MaintenanceReportExport;